import { computed } from "vue"
import { useStore } from "vuex"

export function useCheckout() {
  const store = useStore()
  const checkout = computed(() => store.state.checkout.checkout)
  const isReady = computed(() => store.state.checkout.isReady)
  const invoiceAddress = computed({
    get: () => store.state.checkout.checkout?.invoice_address,
    set: (val) => store.commit('checkout/SET_INVOICE_ADDRESS', val)
  })
  const shippingAddress = computed({
    get: () => store.state.checkout.checkout?.delivery_address,
    set: (val) => store.commit('checkout/SET_SHIPPING_ADDRESS', val)
  })
  const activePaymentMethod = computed({
    get: () => store.state.checkout?.activePaymentMethod,
    set: (val) => store.dispatch('checkout/setPaymentMethod', val)
  })
  const isGermany = computed(() => {
    return shippingAddress.country === "DE"
  })

  const hideInvoiceAddress = computed(() => {
    return shippingAddress.station_deliver === "station"
  })

  const errors = computed(() => store.state.checkout.errors)

  const setInvoiceAddress = (addressId) => store.dispatch('checkout/setInvoiceAddress', addressId)
  const setShippingAddress = (addressId, sameAsInvoice) => store.dispatch('checkout/setShippingAddress', { addressId, sameAsInvoice })

  function clearFieldError (type, field) {
    if (store.state.checkout.errors[type]?.[field]) {
      store.commit('checkout/CLEAR_FIELD_ERROR', { type, field })
    }
  }

  const getCheckout = () => store.dispatch('checkout/getCheckout')
  const validateAddresses = () => store.dispatch('checkout/validateAddresses')

  return {
    errors,
    isReady,
    checkout,
    isGermany,
    getCheckout,
    invoiceAddress,
    shippingAddress,
    clearFieldError,
    validateAddresses,
    setInvoiceAddress,
    hideInvoiceAddress,
    setShippingAddress,
    activePaymentMethod,
  }
}